import communication from "./communication";
import compliance from "./compliance";
import dashboard from "./dashboard";
import financial from "./financial";
import genealogy from "./genealogy";
import members from "./members";
import monthlyPrizes from "./monthlyPrizes";
import reports from "./reports";
import settings from "./settings";
import statistics from "./statistics";
import store from "./store";
import subAdmin from "./subAdmin";
import subscriptions from "./subscriptions";
import telegram from "./telegram";
import tools from "./tools";
import training from "./training";
import user from "./user";

const routes = [
  ...communication,
  ...compliance,
  ...dashboard,
  ...financial,
  ...genealogy,
  ...members,
  ...monthlyPrizes,
  ...reports,
  ...settings,
  ...statistics,
  ...store,
  ...subAdmin,
  ...subscriptions,
  ...telegram,
  ...tools,
  ...training,
  ...user,
];

export default routes;
